<template lang="pug">
div
	.position-relative
	// Hero for FREE version
	section.section.section-lg.section-hero.heroPlastomex
		div(style='height: fit-content')
			h1.h-titulo Bolsa de Trabajo
			p.lead.h-subtitulo  Por una cultura de servicio para tu bienestar
	// You write code for this content block in another  file
	.container
		section#vacantes
			.row
				.col-12
					p
						| En Plastomex buscamos personas con una visión humana y sensible hacia el entorno y medio ambiente. Fabricamos con pasión y calidad cajas y rafias plásticas hechas con material reciclado, contribuyendo de esta forma a mantener un equilibrio con el medio ambiente, sin descuidar la satisfacción de nuestros clientes.
				.col-12
					h2.sublinea-centro  ÚNETE A NUESTRO EQUIPO
					p.text-center
						| Conoce nuestras vacantes disponibles y forma parte de la familia 
						strong PLASTOMEX
						| :

			.row.mt-5.mx-0.justify-content-center
				.col.my-4(v-for="v in vacantes")
					.card.card-lift--hover.shadow.border-0.text-center
						.card-body.px-0.py-5
							h6.text-primary.text-uppercase.px-4 {{v.titulo}}
							button.btn.btn-primary.btn-sm.mt-4(@click="show_modal(v)") Ver detalles
				
		b-modal(v-model='modal' size="lg")
			h6#modal-title-default.modal-title(slot='header') 
			.modal-body(v-if="modal")
				h4.titulo-producto {{vacante_s.titulo}}
				p Como 
					strong {{vacante_s.titulo}} 
					| estarás a cargo de: 
					br 
					| {{vacante_s.descripcion}}
				.row.justify-content-center
					.col-12.col-lg-6.text-left
						h5 Actividades:
						ul
							li(v-for="a in vacante_s.actividades") {{ a }}
						h5 Requisitos:
						ul
							li(v-for="r in vacante_s.requisitos") {{ r }}
						h5 Ofrecemos:
						ul
							li(v-for="b in vacante_s.beneficios") {{ b }}
			template(slot='modal-footer')
				base-button.ml-auto(type='secondary', @click="modal = false") X

		section#aplicacion.mt-5
			.row
				.col-12
					h2.my-4.text-center Aplica y se parte de nuestro equipo
					form#bolsa(@submit.prevent='contacto()')
						.row
							.col-md-6
								//-base-input(placeholder='Nombre completo')
								//-base-input(placeholder='Nombre completo' type='file')
								
								//-.form-group
									label(for='nombre') Nombre completo
									input#nombre.form-control(type='text', placeholder='Nombre completo' v-model='form.nombre' required )
								base-input#nombre(placeholder='Nombre completo' v-model='form.nombre' required)
								//-.form-group
									label(for='domicilio') Domicilio
									input#domicilio.form-control(type='text', placeholder='Domicilio' v-model='form.domicilio')
								base-input(placeholder='Domicilio' v-model='form.domicilio')
								//-.form-group
									label(for='cp') Codigo Postal
									input#cp.form-control(type='number', min='0', maxlength='5', name='cp', placeholder='Codigo Postal' v-model='form.cp')
								base-input(placeholder='Codigo Postal' v-model='form.cp' pattern="[0-9]{5}" title=" 5 digitos de codigo postal")
								//-.form-group
									label(for='telefono') Teléfono
									input#telefono.form-control(type='tel', minlength='10'  required name='telefono', placeholder='Teléfono' v-model='form.telefono')
								base-input(placeholder='Teléfono' v-model='form.telefono' type="tel" pattern="[0-9]{10}" title=" 10 digitos telefónicos")
								//-.form-group
									label(for='email') Email
									input#email.form-control(type='email', required name='email', placeholder='Email' v-model='form.email')
								base-input(placeholder='Email' v-model='form.email' type="email")
							.col-md-6
								//-.form-group
									label(for='aexpreriencia') Area de Experiencia
									input#aexpreriencia.form-control(type='text', placeholder='Area de Experiencia' v-model='form.aexpreriencia')
								base-input(placeholder='Area de Experiencia' v-model='form.aexpreriencia')
								//-.form-group
									label(for='ainteres') Area de Interés
									input#ainteres.form-control(type='text', required placeholder='Area de Interés' v-model='form.ainteres')
								base-input(required placeholder='Area de Interés' v-model='form.ainteres')
								//-.form-group
									label(for='dependientese') Cantidad de Dependientes ecnonómicos
									input#dependientese.form-control(type='number', min='0', name='dependientese', placeholder='Cantidad de Dependientes ecnonómicos' v-model='form.dependientese')
								
								b-form-select(v-model="form.estadoc" placeholder='Estado Civil' :options="options")
								//-.form-group
									label(for='estadoc') Estado Civil
									select#estadoc.form-control(v-model='form.estadoc')
										option Soltero
										option Casado
										option Divorciado
										option Viudo
										option Otro 

								b-form-file.my-3( no-drop
												accept=".pdf", name='cv' @change='subirCV' ref="archivo"
												placeholder="Selecciona tu archivo...")
								//-.form-group
									label(for='cv') Sube tu C.V. o Solicitud de empleo en PDF
									input#cv.form-control(type='file' accept=".pdf", name='cv' @change='subirCV' ref="archivo")
							.col-12.text-center
								button.btn.btn-primary(type='submit') Enviar

						b-alert.mt-5(v-model='alert.show', :variant='alert.variant', dismissible) {{ alert.txt }}


</template>

<script>
// import { vacantes } from '@/data/vacantes'
	export default {
		data(){
			return{
				vacantes:[],
				vacante_s:{},
				file:null,
				modal:false,
				form:{from:'bolsa', estadoc:null},
				cv:null,
				options:[
					{value:null,text:'Selecciona tu estado civil'},
					{value:'Soltero',text:'Soltero'},
					{value:'Casado',text:'Casado'},
					{value:'Divorciado',text:'Divorciado'},
					{value:'Viudo',text:'Viudo'},
					{value:'Otro',text:'Otro'}
					],
				alert:{
					show: false,
					txt:''
					},
				
			}
		},
		created(){
			fetch('/data/vacantes.json')
			.then( response => response.json() )
			.then(data => {
				this.vacantes = data
				console.log(data)
			} )
			.catch( err => console.error(err ) )
		},
		methods: {
			show_modal: function(vacante) {
				this.vacante_s = vacante
				// console.log(this.vacante_s)
				this.modal = true
			},
			contacto(){
				if(this.cv != null){
					let fd = new FormData()
					fd.append('cv', this.cv)
					fd.append('data', JSON.stringify(this.form))
					//console.log(fd);			
					fetch('https://mail.plastomex.com/sendmail', {
						method:'post',
						body: fd,
						mode: 'cors'
					})
					.then(response => response.json())
						.catch(error => {
							this.$swal('Error','Error al enviar el mensaje','error')
							console.error('Error:', error)
						}
						)
						.then( data => { 
							if(data.messageId)
								this.$swal('Enviado','El mensaje se envió correctamente','success');
							console.log(data) 
							})				
				}else{
					fetch('https://mail.plastomex.com/sendmail', {
						method:'post',
						body: JSON.stringify(this.form),
						headers:{'Content-Type': 'application/json' },
						mode: 'cors'
					})
					.then(response => response.json())
						.catch(error => {
							this.$swal('Error','Error con el servidor al enviar el mensaje','error')
							console.error('Error:', error)
						})
						.then( data => { 
							console.log(data) 
							console.log(data.messageId)
							if(data.messageId) 
								this.$swal('Enviado','El mensaje se envió correctamente','success');
							else
								this.$swal('No enviado','Error al enviar el mensaje','error');
							
						}) 
				}
			},
			subirCV(evt){
				//console.log(evt.target.files[0]);
				
				if(evt.target.files[0].name.split('.').pop() == 'pdf' ){
					if(evt.target.files[0].size > 5200000 ){
						this.$refs.archivo.value = null
						this.$swal('Error','El tamaño limite es de 4.5 MB','error');
						/* this.alert.variant = 'warning'
						this.alert.txt = 'El tamaño limite es de 4.5 MB'
						this.alert.show = true	 */
					}
					else{
						//console.log('ahora si ');
						this.cv = evt.target.files[0]
					}
				}	
				else{
					this.$swal('Error','Solo se aceptan formatos pdf','error');
					this.$refs.archivo.value = null
					/* this.alert.variant = 'warning'
					this.alert.txt = 'Solo se aceptan formatos pdf'
					this.alert.show = true */	
				}	
			}
		}
	}
</script>

<style lang="scss" scoped >
.custom-file-label::after {
  content: 'Explorar';
}
.heroPlastomex{
	background-image: url('/img/optimizadas/IMG_7055.jpg');
}
.webp .heroPlastomex{
	background-image: url('/img/optimizadas/IMG_7055.webp');
}
</style>